import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { Store } from "@ngrx/store";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DateProvider } from "src/app/_models/DateProvider";
import { Userprofile } from "src/app/_models/Userprofile";
import { selectGetDateProvider } from "src/app/_store/date-provider/date-provider.selector";
import { GetOwnUserProfile } from "src/app/_store/user-profile/user-profile.actions";
import { selectOwnUserProfile } from "src/app/_store/user-profile/user-profile.selectors";
import { Roles } from "src/app/constants/Roles";

@Component({
  selector: "app-copyright",
  templateUrl: "./copyright.component.html",
  styleUrls: ["./copyright.component.scss"]
})
export class CopyrightComponent implements OnInit, OnDestroy {

  isLoggedIn: boolean = false;
  dateProvider$: Observable<DateProvider>;
  copyRightDestroy$: Subject<void> = new Subject<void>();
  isAdmin: boolean = false;
  adminRoles: Roles[] = [Roles.SystemAdministrator, Roles.OrganisationalAdministrator, Roles.ContentAdministrator, Roles.GlobalAdministrator, Roles.Tutor];

  constructor(private authService: MsalService, private store: Store) { }

  ngOnInit(): void {
    this.isLoggedIn = this.authService.instance.getAllAccounts().length > 0;

    this.dateProvider$ = this.store.select(selectGetDateProvider);

    if(this.isLoggedIn)
    {
      this.store.dispatch(GetOwnUserProfile());
    }

    this.store.select(selectOwnUserProfile)
    .pipe(takeUntil(this.copyRightDestroy$))
    .subscribe((userProfileResponse: Userprofile) => {
      if (userProfileResponse !== null) {
        this.isAdmin = this.adminRoles.includes(userProfileResponse.roleId);
      }
    });
  }

  ngOnDestroy(): void {
    this.copyRightDestroy$.next();
    this.copyRightDestroy$.unsubscribe();
  }

}
